import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Billing from "./Billing";

function BillingWrapper() {
  const navigate = useNavigate();

  useEffect(() => {
    const auth = localStorage.getItem("auth");

    if (!auth) {
      navigate("/login?redirect=/billing", { replace: true });
    }
  }, [navigate]);

  return localStorage.getItem("auth") ? <Billing /> : null;
}

export default BillingWrapper;
